/**
 * WHICH tab's content the rail body draws (fix D / R3). The same pure pair the
 * strip uses (`tabSpec.ts`), so the two can never disagree, and one
 * `useShallow` selector + one ui read — a tab swap costs ONE render of this
 * leaf, and nothing in here moves per move.
 */
import {useShallow} from 'zustand/react/shallow';

import {useLiveGame} from '@/Store/liveGameStore';

import {useV2Ui} from '../../../theme/useV2Ui';
import type {V2RailTab} from '../../../theme/useV2Ui';
import {activeTab, selectRailTabInput, tabsFor} from '../tabSpec';

export type TabBodyModel = {
  tab: V2RailTab;
};

export function useTabBodyModel(): TabBodyModel {
  const input = useLiveGame(useShallow(selectRailTabInput));
  const railTab = useV2Ui(s => s.railTab);
  return {tab: activeTab(tabsFor(input), railTab)};
}

export default useTabBodyModel;
